import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as Constants from "../../../shared/Constants";
import * as actions from '../../../store/actions/index';
import {clearForm, decodeBase64} from "../../../shared/utility";
import Spinner from '../../../UI/Spinner/Spinner';
import DisplayBox from '../../../hoc/DisplayBox/DisplayBox';
// import Message from '../../../components/Message/Message';
import Modal from '../../../UI/Modal/Modal';
import AddEligConfirm from '../../../components/AddEligibilityConfirmation/AddEligbilityConfirmation';
import DynamicPortalForm from '../../PortalForm/DynamicPortalForm';
import ModifyEligConfirm from '../../../components/ModifyEligibilityConfirmation/ModifyEligbilityConfirmation';

export class AddEligibiity extends Component {

    //TTODO: selected member should be available, otherwise redirect to search
    //TTODO: prepopulate user mdm first name, last name and dob
    //TTODO: redirect to member elig page after elig is added successfully

    state = {
        formData: null,
    }

    componentDidMount() {
        let uuid = this.props.match.params.uuid;
        uuid && this.props.selectMember({uuid: decodeBase64(uuid)});
        if (!this.props.sdkPortalList) {
            this.props.fetchPortalConfig();
        }
        if(!this.props.portalsList || !this.props.portalsList.length > 0) {
            this.props.fetchPortals();
        }
        window.scrollTo(0, 0);
    }

    toggleModalHandler = (formData) => {
        // console.log("[Member Eligibility] toggleModalHandler formData", formData);
        if(formData.targetPortal === "CAP") {
            this.props.fetchFaroId(formData);
        } else if((this.props.selectedPortal.portalShortName === 'BSCA' || this.props.selectedPortal.portalShortName === 'HARVARDPILGRIM' || this.props.selectedPortal.portalShortName === 'MORGANWHITE')
                     && !this.props.selectedPortal.isPePortal){
            formData.portalIndicator = this.props.selectedPortal.portalShortName;
            this.props.fetchGroupId(formData);
        } else {
            this.props.toggleAddEligModal();
        }
        this.setState({formData: formData});
    }

    addEligibilityHandler = (formData) => {
        if (this.props.selectedPortal.isSdkPortal || this.props.selectedPortal.isPePortal) {
            this.addEligibilitySdkHandler(formData, "ADD");
        } else {
            // console.log("[AddAccount] addAccountHandler - formData - ", formData );
            //TTODO: check if duplicate portal record is duplicate with existing portal Records
            formData = {
                ...formData,
                targetPortal : this.props.selectedPortal.parentPortalId && this.props.selectedPortal.portalBrandName ? this.props.selectedPortal.portalBrandName : formData.targetPortal,
                healthSafeId: this.props.member.healthSafeId,
                requestType: "PORTAL",
                userName: this.props.member.essoData.userName
            }        
            if(this.props.selectedPortal.portalShortName === 'BSCA' || this.props.selectedPortal.portalShortName === 'HARVARDPILGRIM' || this.props.selectedPortal.portalShortName === 'MORGANWHITE'){
                formData.GroupId = this.props.memberGroupID;
            }
            this.props.addEligibility(formData, "ADD", this.props.location.state.idType);
        }
    }

    modifyEligibilityHandler = (formData, memberPortalId, prevInfoObject) => {
        if (this.props.selectedPortal.isSdkPortal || this.props.selectedPortal.isPePortal) {
            this.addEligibilitySdkHandler(formData, "MODIFY");
        } else {
            formData = {
                ...formData,
                addEligibilityPrevInfo : prevInfoObject,
                targetPortal : this.props.selectedPortal.parentPortalId && this.props.selectedPortal.portalBrandName ? this.props.selectedPortal.portalBrandName : formData.targetPortal,
                healthSafeId: this.props.member.healthSafeId,
                requestType: "PORTAL",
                memberPortalId: memberPortalId,
                userName: this.props.member.essoData.userName
            }
            this.props.addEligibility(formData, "MODIFY", this.props.location.state.idType);
        }
    }

    addEligibilitySdkHandler = (formData, operation) => {
        delete formData['targetPortal'];
        let memberInfo = {
            uuid: this.props.member.healthSafeId,
            userPortalDetails:{
                "portal":this.props.selectedPortal.portalShortName.toLowerCase(),
                "portalIndicator":this.props.selectedPortal.portalShortName.toLowerCase(),
                "isPePortal" : this.props.selectedPortal.isPePortal,
                ...formData
            },
            userName: this.props.member.essoData.userName
        };
        this.props.addSdkEligibility(memberInfo, operation, this.props.location.state.idType);
        

    }

    clearFormData = (portalForm, ignoreFields) =>{
        // console.log("[AddAccount] clearFormData", targetPortal);
        this.props.setDisplayMessage(null);
        return clearForm(portalForm, ignoreFields);
    }

    setEligibilityData = (form, selectedPortal) => {
        // console.log("[Add Eligibility] setEligibilityData", form, form["targetPortal"]);
        delete form["UUID"];

        let elems = [{formName: "FirstName", fieldName: "mdmFirstNm"}, {formName: "LastName", fieldName: "mdmLastNm"}, { formName: "DOB", fieldName: "mdmDob"}, { formName: "ZipCode", fieldName: "mdmZip"}];

        if(this.props.member && selectedPortal) {
            for(let key in elems) {
                let formElement = {...form[elems[key].formName]}
                // console.log("[Add Eligibility] setEligibilityData formElement data", key, formElement, form);
                formElement["value"] = this.props.member[elems[key].fieldName];
                form = {...form, [elems[key].formName]: formElement};
                // console.log("[Add Eligibility] setEligibilityData formElement data", key, formElement, form);
            }
        }
        // console.log("[Add Eligibility] setEligibilityData after", form);
        return form;
    }

    isSdkPortal = (sdkPortal, pePortal) => {
                this.setState(
                    {...this.state,
                    sdkPortal : sdkPortal,
                    pePortal : pePortal}
                )
            }

    findCurrEligibility = (eligibilities, formData) => {
        if (!eligibilities || eligibilities.length < 1) {
            return undefined;
        }
        switch (formData.targetPortal) {
            case 'MYUHC':
                return eligibilities.find(x => x.portalPolicyNbr === ((this.props.selectedPortal.isPePortal) ? formData.groupNumber : formData.GroupId));
            default:
                return eligibilities[0];
        }
    }

    filterZipCodeOrNoInsurance = (portalList) => {
        const newPortalList = [];
        portalList
        .map((portal, index) => {
            const isTeir1 = portal.uiConfig?.features?.accountType === 'TIER1';
            if (!isTeir1){
                return portal;
            }else {
                const newPortalData = {...portal}
                const uiIdentificationType = [...newPortalData.uiConfig?.uiIdentificationTypes];
                newPortalData.uiConfig.uiIdentificationTypes = [];
                uiIdentificationType.forEach(ui => {
                    const elements = [...ui.elements];
                    let containsZipOnly = true;
                    elements.forEach(ele => {
                        if (Constants.identifiers.has(ele.id)) {
                            containsZipOnly = false;
                        }
                    })
                    if (!containsZipOnly) {
                        newPortalData.uiConfig.uiIdentificationTypes.push(ui);
                    }
                })
                return newPortalData;
            }
        })
        .forEach((portal) => {
            if (portal.portalShortName in Constants.portalsWithNoIdentification) {
                const uiIdentificationType = portal.uiConfig?.uiIdentificationTypes;
                uiIdentificationType.forEach(ui => {
                    ui.elements.forEach(ele => {
                        if (Constants.identifiers.has(ele.id) && !ele.label) {
                            ele.label = Constants.portalsWithNoIdentification[portal.portalShortName];
                        }
                    })
                });
            }
            newPortalList.push(portal);
        })
        return newPortalList;
    }

    render() {
        // console.log("[Add Eligibility] render", this.props.member);
        let form = <Spinner/>;
        // if(this.props.eligibilityAdded) {
        //     this.props.history.push("/member");
        // } else
        if(this.props.member && !this.props.portalsLoading && !this.props.portalInfoLoading && !this.props.loading) {
            const portalList = this.filterZipCodeOrNoInsurance(this.props.portalsList);
            if(Object.keys(this.props.member.essoData).length !== 0) {
                form = (
                    <DynamicPortalForm
                        formHeader = {Constants.ADD_ELIGIBILITY}
                        formMessage = {Constants.ADD_ELIGIBILITY_ALL_FIELDS_REQUIRED}
                        message = {this.props.message}
                        selectedPortal = {this.props.selectedPortal}
                        portalsList = {portalList}
                        portalsInfo = {this.props.portalsInfo}
                        portalInfoLoading = {this.props.portalsLoading}
                        submitButtonLabel = {Constants.LABEL_SAVE}
                        submitFormHandler = {this.toggleModalHandler}
                        resetFormHandler = {this.clearFormData}
                        portalSelectHandler = {this.props.setAddEligibilityPortal}
                        displayMessageHandler = {this.props.setDisplayMessage}
                        addFunctionSpecificData = {this.setEligibilityData}
                        memberInfo = {this.props.member}
                        setModifyEligibilityPortal = {this.props.setModifyEligibilityPortal}
                        isSdkPortal = {this.isSdkPortal}
                    />
                );
            } else {
                form = (
                    <DisplayBox>
                        <Redirect to="/search"></Redirect>
                    </DisplayBox>
                );
            }

            
        }
        let confirmModal = null;
        if (this.props.showAddEligModal) {
            const modifyEligPortal = this.findCurrEligibility(this.props.modifyEligPortal, this.state.formData);
            if (modifyEligPortal) {
                confirmModal = (
                    <Modal show={this.props.showAddEligModal && this.state.formData} modalClosed={this.toggleModalHandler}>
                        <ModifyEligConfirm
                            modifyEligPortal = {modifyEligPortal}
                            updatedFormData={this.state.formData}
                            memberInfo={this.props.member}
                            selectedPortal={this.props.selectedPortal}
                            updateEligibility={this.modifyEligibilityHandler}
                            cancelled={this.toggleModalHandler}
                            faroId = {this.props.memberFaroID}
                            isSdkPortal = {this.state.sdkPortal || this.state.pePortal}
                            portals={this.props.portalsList}
                        />
                    </Modal>
                );
            } else {
                confirmModal = (
                    <Modal show={this.props.showAddEligModal} modalClosed={this.toggleModalHandler}>
                        <AddEligConfirm
                            //modifyEligPortal = {this.props.modifyEligPortal}
                            updatedFormData={this.state.formData}
                            memberInfo={this.props.member}
                            selectedPortal={this.props.selectedPortal}
                            addEligibility={this.addEligibilityHandler}
                            cancelled={this.toggleModalHandler}
                            memberGroupID = {this.props.memberGroupID}
                            isSdkPortal = {this.state.sdkPortal || this.state.pePortal}
                            portals={this.props.portalsList}
                        />
                    </Modal>
                );
            }
        }
        // console.log("[AddAccount] render", this.props);
        return (
            <Fragment>
                {confirmModal}
                {form}
            </Fragment>
        );
    }
}

export const mapStateToProps = state => {
    return {
        selectedPortal: state.addEligibility.addEligPortal,
        message: state.addEligibility.message,
        portalsList: state.addEligibility.portals,
        portalsInfo: state.addEligibility.portalsInfo,
        portalsLoading: state.addEligibility.portalsLoading,
        portalInfoLoading: state.addEligibility.portalInfoLoading,
        member: state.member.member,
        eligibilityAdded: state.addEligibility.eligibilityAdded,
        showAddEligModal: state.addEligibility.showAddEligModal,
        memberGroupID: state.addEligibility.memberGroupID,
        modifyEligPortal: state.addEligibility.modifyEligPortal,
        sdkPortalList: state.member.sdkPortalList,
    }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        addEligibility: (memberInfo, operation, idType) => dispatch(actions.addEligibility(memberInfo, ownProps.history, operation, idType)),
        addSdkEligibility: (memberInfo, operation, idType) => dispatch(actions.addSdkEligibility(memberInfo, ownProps.history, operation, idType)),
        //TTODO: Not needed: update
        // addBankEligibility: (memberInfo) => dispatch(actions.addBankEligibility(memberInfo, ownProps.history, "ADD")),
        //TTODO: Done: update
        setDisplayMessage: (message) => dispatch(actions.setEligDisplayMessage(message)),
        setAddEligibilityPortal: (portalInfo) => dispatch(actions.setAddEligibilityPortal(portalInfo)),
        fetchPortals: () => dispatch(actions.fetchEligibilityPortals()),
        fetchFaroId: (formData) => dispatch(actions.fetchFaroId(formData, "ADD")),
        fetchGroupId: (formData) => dispatch(actions.fetchGroupId(formData, "ADD")),
        toggleAddEligModal: () => dispatch(actions.toggleAddEligModal()),
        selectMember: (selectedMember) => dispatch(actions.selectMember(selectedMember)),
        setModifyEligibilityPortal: (portalInfo) => dispatch(actions.setModifyEligibilityPortal(portalInfo, ownProps.history)),
        fetchPortalConfig: () => dispatch(actions.fetchPortalConfig()),
        mergePortalList: (portalsList, sdkPortalList) => dispatch(actions.mergePortalList(portalsList, sdkPortalList))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEligibiity);
